import React, {createPortal, useEffect} from "preact/compat";
import {CheckOutlined} from "@ant-design/icons";
import {useState} from "preact/hooks";
import {TemplateColor} from "../typings/types";

export interface EditTemplateColorsModalProps {
  open: boolean;
  onClose: () => void;
  colors: string[];
  onColorsChange: (colors: string[]) => void;
  getDesignColorBg: (color: string) => string;
}

export default function EditTemplateColorsModal({open, colors, onClose, onColorsChange, getDesignColorBg}: EditTemplateColorsModalProps) {
  const [selectedColors, setSelectedColors] = useState([] as TemplateColor[]);
  const [allChecked, setAllChecked] = useState(true);

  useEffect(() => {
    setSelectedColors(colors.map(color => {
      return {color, selected: true} as TemplateColor
    }));
  }, [colors]);

  function triggerColor(e: any, idx: number) {
    e.stopPropagation();
    setSelectedColors([
      ...selectedColors.slice(0, idx),
      {...selectedColors[idx], selected: !selectedColors[idx].selected},
      ...selectedColors.slice(idx + 1)
    ]);
  }

  function onSave() {
    onColorsChange(selectedColors.filter(it => it.selected).map(it => it.color));
  }

  function toggleAllColors() {
    let toCheck = !allChecked;
    setSelectedColors(colors.map(color => {
      return {color, selected: toCheck} as TemplateColor
    }))
    setAllChecked(!allChecked);
  }

  return open ? createPortal(<div>
    <div className="modal-back" onClick={onClose}/>
    <div className="modal" onClick={e => e.stopPropagation()}>
      <header>
        <h2>Edit template colors</h2>
      </header>
      <div className="content">
        <ul className={'colors edit-template-colors'}>
          {selectedColors.map((entry, idx) =>
            <li className={'edit-template-color'} onClick={(e) => triggerColor(e, idx)} style={'background: ' + getDesignColorBg(entry.color)}>
              {entry.selected && <CheckOutlined/>}
            </li>)}
        </ul>
        <div style="display: flex; width: 50px;">
          <input type="checkbox" id="toggleAllColorsCheckbox" checked={allChecked} onClick={() => toggleAllColors()} />
          <label>All</label>
        </div>

        <footer>
          <a className="btn decline" onClick={onClose}>Cancel</a>
          <a className="btn primary accept" onClick={onSave}>Ok</a>
        </footer>
      </div>
    </div>
  </div>, document.getElementById('modals')!) : null;
}
